import { createNamespacer, createReducer } from "../commons/js/utils/reducer";

const initialState = {
    currentPage:1,
    totalPages:1,
    packageDetails: {},
    packageOptions: [],
    loading: false,
    miscTasksData: [],
    miscState: "",
    miscRequiredDate: "",
    misc_fab_items_attributes: {},
    dup_items: {},
    miscCategory: "",
    miscDescription: "",
    miscTotalTaskPercentage:"",
    projectCode: "",
    projectName: "",
    packageName: "",
    miscDataResponse: null,
    miscCategoryList: [],
    selectedCategory: {label: "", value: null},
    currentDescription: "",
}

const miscFabTask = createNamespacer("MISC_TASK_LIST");

const miscFabTaskReducer = createReducer(initialState, {

    [miscFabTask("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            loading: action.payload.value,
        }
    },
    [miscFabTask("SET_MISC_FAB_CATEGORY_LIST")]: (state, action) => {
        return {
            ...state,
            miscCategoryList: action.payload.value,
        }
    },
    [miscFabTask("SET_SELECTED_CATEGORY")]: (state, action) => {
        return {
            ...state,
            selectedCategory: {...action.payload.value},
        }
    },
    [miscFabTask("SET_DESCRIPTION")]: (state, action) => {
        return {
            ...state,
            currentDescription: action.payload.value,
        }
    },
    [miscFabTask("SET_MISC_RESPONSE")]: (state, action) => {
        return {
            ...state,
            miscDataResponse: action.payload.value,
        }
    },
    [miscFabTask("SET_MiSC_TASK_DATA")]: (state, action) => {
        return {
            ...state,
            miscTasksData: action.payload.value,
            miscState: action.payload.miscState,
            miscRequiredDate: action.payload.miscRequiredDate,
            currentPage: action.payload.currentPage,
            totalPages: action.payload.totalPages,
            misc_fab_items_attributes: {},
            miscCategory: action.payload.miscCategory,
            miscDescription: action.payload.miscDescription,
            miscTotalTaskPercentage: action.payload.miscTotalTaskPercentage,
            projectCode: action.payload.projectCode,
            projectName: action.payload.projectName,
            packageName: action.payload.packageName,
        }
    },
    [miscFabTask("SET_PERCENTAGES")]: (state, action) => {

        let updatedTaskPercentages = {}

        updatedTaskPercentages = { ...state.misc_fab_items_attributes }
        if(action.payload.taskId){
            updatedTaskPercentages[action.payload.taskId] = {
                ...updatedTaskPercentages[action.payload.taskId],
                task_percentage : action.payload.taskPercentage,
                weightage_percentage: action.payload.weightPercentage,
            }
        }
        else if(action.payload.category){
            for(let i=0; i < action.payload.data.length; i++){
                updatedTaskPercentages[action.payload.data[i].id] = {
                    ...updatedTaskPercentages[action.payload.data[i].id],
                    category : action.payload.category,
                }
            }
        }
        else if(action.payload.description){
            for(let i=0; i < action.payload.data.length; i++){
                updatedTaskPercentages[action.payload.data[i].id] = {
                    ...updatedTaskPercentages[action.payload.data[i].id],
                    description: action.payload.description
                }
            }
        }

        return {
            ...state,
            misc_fab_items_attributes: { ...updatedTaskPercentages },
        }

    },
})

export default miscFabTaskReducer;